import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

interface Props extends SvgIconProps {
    // todo any custom additional property
}

/**
 * @source
 * - https://stackoverflow.com/questions/38510443/how-to-use-an-svg-file-in-a-svgicon-in-material-ui
 * @param props
 * @constructor
 */
const Zircon = (props: Props) => {
    return <SvgIcon
        className={props.className}
        component={props.component!}
        viewBox={props.viewBox ?? "0 0 512 512"}
        fontSize={props.fontSize ?? "large"}
        {...props}
    ></SvgIcon>
};

export default Zircon;